import { generateJSON } from '@tiptap/core';
import type { JSONContent } from '@tiptap/react';
import { RICH_TEXT_EXTENSIONS } from './richTextExtensions';

export function toInlineHtmlContent(html: string): JSONContent[] {
  const parsed = generateJSON(html || '<p></p>', RICH_TEXT_EXTENSIONS) as JSONContent;
  const paragraphs = parsed.content ?? [];
  return paragraphs.flatMap((paragraph, index) => [
    ...(index === 0 ? [] : [{ type: 'hardBreak' }]),
    ...(paragraph.content ?? []),
  ]);
}

export function inlineContentPlainTextLength(content: JSONContent[]): number {
  return content.reduce(
    (total, node) => total + (node.type === 'hardBreak' ? 1 : (node.text ?? '').length),
    0
  );
}
